import { Button } from '@mui/material';
import styled from 'styled-components';

export const SearchBoxHeader = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
  text-transform: uppercase;
  color: #263238;
  margin-bottom: 4px;
  padding: 3px 0;
`;

export const AddPhotosButton = styled(Button)`
  &:disabled {
    background: #1565c0;
    mix-blend-mode: normal;
    opacity: 0.5;
    color: #ffffff;
  }
`;

export const SelectJobDialogContent = styled.div`
  width: 552px;
`;

export const CircularProgressContainer = styled.div`
  display: flex;
  justify-content: center;
`;
